
const getters = {
  isLoading: state => state.isLoading,
  isCat: state => state.isCat,
  animalIdx: state => state.animalIdx,
  loginTime: state => state.loginTime,
  nickname: state => state.name,
};

export default getters;



// WEBPACK FOOTER //
// ./src/stores/getters.js